import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from '../../services/global-variables';
import { ApiService } from '../../services/api.service';
import { BrowserStorageService } from 'src/app/services/browser-storage.service';

export type offer = {
    id: string,
    merchantLogoUrl: string,
    offerType: string,
    endDate: string,
    merchantName: string,
    merchantId: string,
    redemptionUrl: string,
    offerTitle: string,
    isNearby: any,
    forCampaign: any;
    image_url?:any
}

@Component({
    selector: 'app-poshvine-voucher-card-secondary',
    templateUrl: './voucher-card-secondary.component.html',
    styleUrls: ['./voucher-card-secondary.component.scss']
})
export class VoucherCardSecondaryComponent {
    public assetsPath = './../../../assets';
    @Input() selectedOffer: offer = {} as offer;
    copiedCode: boolean = false;
    couponLoading: boolean = false;
    redeemActive: boolean = false;
    redeeming = false;
    voucherData: any = {};
    emitRedeem = new EventEmitter<boolean | 'redemptionSuccess'
        | 'redemptionFailure' | 'openTerms'>();
    termsOpen: EventEmitter<any> = new EventEmitter();
    @Output() hideEvent: EventEmitter<boolean> = new EventEmitter();
    constructor(
        public GlobalConstants: GlobalConstants,
        private _apiService: ApiService,
        private toastr: ToastrService,
        private browserStore: BrowserStorageService,
        private ngbModal: NgbActiveModal
    ) { }

    ngOnInit(): void {
        this.proceedToRedeem();
    }

    proceedToRedeem() {
        this.couponLoading = true;
        let params = JSON.parse(this.browserStore.get('cardSelected')) || {};
        console.log(this.selectedOffer);
        if (this.selectedOffer.forCampaign) {
            const currentUserCard = JSON.parse(this.browserStore.get("userCard"));
            const currentUser = JSON.parse(this.browserStore.get("currentUser") || "{}");
            this._apiService.redeemCampaignOffer(this.selectedOffer.forCampaign.campaignId,
                this.selectedOffer.forCampaign.offer_redemption_id,
                { user_id: currentUser.id, card_id: currentUserCard.id }).subscribe(
                (res: any) => {
                    this.couponLoading = false;
                    const keyy = Object.keys(res)[0];
                    this.voucherData = res[keyy];
                },
                (err) => {
                    if (err.status && err.status === 401) {

                        this.emitRedeem.emit('redemptionFailure');
                    }
                    else {
                        this.couponLoading = false;
                        this.voucherData.success = false;
                    }
                }
            );
        } else {
            this._apiService.redeem({ id: this.selectedOffer.id }, params, this.selectedOffer.isNearby).subscribe(
                (res: any) => {
                    this.couponLoading = false;
                    this.voucherData = res;
                },
                (err) => {
                    if (err.status && err.status === 401) {
                        this.emitRedeem.emit('redemptionFailure');
                    }
                    else {
                        this.couponLoading = false;
                        this.voucherData.success = false;
                    }
                }
            );
        }
    }
    goTo() {
        if (this.GlobalConstants.data.personalized_config.show_terms_before_redeem) {
            this.termsOpen.emit(true);
        }
        else {
            this.redeeming = true;
            console.log(this.selectedOffer,'>>>>>>> goTo selectedOffer');
            let gotourl = this.selectedOffer.redemptionUrl;
            this.emitRedeem.emit('openTerms');
            // console.log(this.selectedOffer,"Redemptions")
            // this.gtmRedeem(this.selectedOffer.)
            setTimeout(() => {
                window.open(gotourl, '_blank');
                this.redeeming = false;
                this.redeemActive = false;
            }, 0)
        }
    }
    showCopied() {
        this.toastr.success('Copied!');
    }
    get returnCorrectURL(){
        return '/offers/offer-details/' + this.selectedOffer?.merchantId + '/all/' + this.selectedOffer?.merchantName?.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase()+'?offer_id='+ this.selectedOffer?.id +'&terms=true';
    }
    closePanel(){
      this.ngbModal.close();
      this.hideEvent.emit(true);
    }
}
